import { defineStore } from 'pinia';
export default defineStore('staticDict', {
    state: () => {
        return {
            staticDict: {},
        };
    },
    actions: {
        setStaticDict(dict) {
            this.staticDict = dict;
        },
    },
});
